import Vue from "vue";

Vue.directive("waiting-animation-infinite", {

    bind(el)
    {
        $(el).click(event =>
        {
            event.currentTarget.classList.add("disabled");
            const hasFloat = event.currentTarget.children[0].className.includes("float-right");
            event.currentTarget.children[0].className = "";
            event.currentTarget.children[0].className = "fa fa-spinner-third fa-spin" + (hasFloat ? " float-right" : "");
        });
    }
});
